import React from 'react';

type FormGridProps = {
  columns: 1 | 2;
  children: React.ReactNode;
};

export function FormGrid({ columns, children }: FormGridProps) {
  return (
    <div
      className={`grid gap-x-4 gap-y-4 ${
        columns === 2 ? 'grid-cols-1 md:grid-cols-2' : 'grid-cols-1'
      }`}
    >
      {children}
    </div>
  );
}
